import { loadStripe, type Stripe } from '@stripe/stripe-js'

/**
 * `loadStripe` fetches and caches Stripe.js itself, but only once per key —
 * calling it again mid-dialog would load a second copy for no reason. The
 * key comes from the setup-intent response at runtime, matching how
 * `apps/web` reaches Stripe.js (see `apps/web/src/lib/stripe.ts`).
 */
let cached: { key: string; promise: Promise<Stripe | null> } | null = null

export function getStripe(publishableKey: string): Promise<Stripe | null> {
  if (!cached || cached.key !== publishableKey) {
    cached = { key: publishableKey, promise: loadStripe(publishableKey) }
  }
  return cached.promise
}
